export default __webpack_public_path__ + "static/media/13-color.e105c8db.svg";